import React from 'react'
import { useAppSelector } from '../../app/hooks'
import { isGlobalLoading } from '../../features/loading/loadingSlice'

export const GlobalLoading: React.FC = () => {
  const loading = useAppSelector(isGlobalLoading)
  if (!loading) return null
  return (
    <div className="fixed inset-0 z-[9999] bg-black/20 flex items-center justify-center">
      <div className="flex items-center space-x-3 bg-white px-4 py-3 rounded shadow">
        <svg className="animate-spin h-5 w-5 text-primary-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        <span className="text-sm text-gray-700">Đang xử lý...</span>
      </div>
    </div>
  )
}





